/**
 * Cart drawer — "Often bought together" PDP-style buy boxes.
 * Uses event delegation because recommendations HTML is injected after fetch.
 */
(function () {
  const DRAWER_ID = 'site-cart-sidebar';

  function inCartDrawer(el) {
    var d = document.getElementById(DRAWER_ID);
    return !!(d && el && d.contains(el));
  }

  function formatMoneyCents(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) {
      return '';
    }
    var format =
      typeof window.KROWN !== 'undefined' &&
      window.KROWN.settings &&
      window.KROWN.settings.shop_money_format
        ? window.KROWN.settings.shop_money_format
        : '{{amount}}';

    var re = /\{\{\s*(\w+)\s*\}\}/;
    var m = format.match(re);
    if (!m) {
      return String(cents / 100);
    }
    function fw(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }
    var key = m[1];
    var val;
    switch (key) {
      case 'amount':
        val = fw(cents, 2);
        break;
      case 'amount_no_decimals':
        val = fw(cents, 0);
        break;
      case 'amount_with_comma_separator':
        val = fw(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        val = fw(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        val = fw(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        val = fw(cents, 2, "'");
        break;
      default:
        val = fw(cents, 2);
    }
    return format.replace(re, val);
  }

  function getVariants(box) {
    var t = box.querySelector('template[data-cart-rec-variants-json]');
    if (!t) return [];
    try {
      return JSON.parse(t.textContent.trim());
    } catch (e) {
      return [];
    }
  }

  function findVariant(box, vid) {
    var id = parseInt(vid, 10);
    return getVariants(box).filter(function (v) {
      return parseInt(v.id, 10) === id;
    })[0];
  }

  function applyFromPill(box, pill) {
    if (!pill || pill.disabled) return;
    var boxEl = pill.closest('[data-cart-rec-buy-box]');
    if (!boxEl) return;
    var hidden = boxEl.querySelector('[data-cart-rec-variant-id]');
    if (hidden) hidden.value = pill.dataset.variantId;

    boxEl.querySelectorAll('[data-cart-rec-pill]').forEach(function (p) {
      p.classList.toggle('cart-rec-buy-box__pill--active', p === pill);
      p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
    });

    var cur = boxEl.querySelector('[data-cart-rec-price-current]');
    var cmpWrap = boxEl.querySelector('[data-cart-rec-price-compare-wrap]');
    var cmp = boxEl.querySelector('[data-cart-rec-price-compare]');
    var savWrap = boxEl.querySelector('[data-cart-rec-save-wrap]');

    if (cur) cur.textContent = pill.dataset.priceFmt || '';

    var hasSale = pill.dataset.hasSale === 'true';

    function showEl(elm, ok) {
      if (!elm) return;
      if (ok) {
        elm.hidden = false;
        elm.removeAttribute('hidden');
        elm.classList.remove('hidden');
      } else {
        elm.hidden = true;
        elm.classList.add('hidden');
      }
    }

    if (cmpWrap && cmp) {
      cmp.textContent = pill.dataset.compareFmt || '';
      showEl(cmpWrap, hasSale);
    }
    if (savWrap) {
      if (hasSale && pill.dataset.saveHtml) {
        savWrap.innerHTML = pill.dataset.saveHtml;
        showEl(savWrap, true);
      } else {
        savWrap.textContent = '';
        showEl(savWrap, false);
      }
    }

    var saveLine = boxEl.querySelector('[data-cart-rec-save-line]');
    if (saveLine) showEl(saveLine, hasSale);

    var sub = boxEl.querySelector('[data-cart-rec-submit]');
    if (sub) sub.disabled = !!pill.disabled;
  }

  function applyFromVariantId(box, variantId) {
    var pill =
      box.querySelector('[data-cart-rec-pill][data-variant-id="' + variantId + '"]') ||
      box.querySelector('[data-cart-rec-pill][data-variant-id="' + String(variantId) + '"]');
    if (pill) {
      applyFromPill(box, pill);
      return;
    }

    var v = findVariant(box, variantId);
    var cur = box.querySelector('[data-cart-rec-price-current]');
    var cmpWrap = box.querySelector('[data-cart-rec-price-compare-wrap]');
    var cmp = box.querySelector('[data-cart-rec-price-compare]');
    var savWrap = box.querySelector('[data-cart-rec-save-wrap]');
    var tmpl = box.getAttribute('data-save-tmpl') || '';

    if (!v) return;

    if (cur) cur.textContent = formatMoneyCents(v.price);

    var compareAt =
      typeof v.compare_at_price === 'number'
        ? v.compare_at_price
        : typeof v.compare_at_price === 'string'
          ? parseInt(v.compare_at_price, 10)
          : 0;
    var variantPrice =
      typeof v.price === 'number' ? v.price : parseInt(v.price, 10);
    var hasSale =
      compareAt && variantPrice !== null && !isNaN(variantPrice) && compareAt > variantPrice;

    function showEl(elm, ok) {
      if (!elm) return;
      if (ok) {
        elm.hidden = false;
        elm.removeAttribute('hidden');
        elm.classList.remove('hidden');
      } else {
        elm.hidden = true;
        elm.classList.add('hidden');
      }
    }

    if (cmpWrap && cmp) {
      cmp.textContent = hasSale ? formatMoneyCents(compareAt) : '';
      showEl(cmpWrap, !!hasSale);
    }
    if (savWrap) {
      if (hasSale) {
        var saveCents = compareAt - variantPrice;
        var saveFmt = formatMoneyCents(saveCents);
        if (tmpl.indexOf('###AMOUNT###') !== -1) {
          savWrap.innerHTML = tmpl.replace(/###AMOUNT###/g, saveFmt);
        } else {
          savWrap.innerHTML = tmpl.replace(/\{\{\s*amount\s*\}\}/gi, saveFmt).replace(/\bamount\b/gi, saveFmt);
        }
        showEl(savWrap, true);
      } else {
        savWrap.textContent = '';
        showEl(savWrap, false);
      }
    }

    var saveLine = box.querySelector('[data-cart-rec-save-line]');
    if (saveLine) showEl(saveLine, hasSale);

    var sub = box.querySelector('[data-cart-rec-submit]');
    if (sub) sub.disabled = !v.available;
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-cart-rec-pill]');
    if (!pill || !inCartDrawer(pill)) return;
    e.preventDefault();
    var box = pill.closest('[data-cart-rec-buy-box]');
    if (!box) return;
    applyFromPill(box, pill);
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('select[data-cart-rec-variant-select]');
    if (!sel || !inCartDrawer(sel)) return;
    var box = sel.closest('[data-cart-rec-buy-box]');
    if (!box) return;
    applyFromVariantId(box, sel.value);
  });
})();
